/* Wise V23 — Photos clients (agent F).
   Mur de photos (mosaïque / carrousel), « Voir plus » mobile, visionneuse accessible
   (flèches clavier, Échap, balayage, piège de focus). Sans dépendance, chargé en defer.
   Initialisation : DOMContentLoaded + shopify:section:load (éditeur de thème). */
(function () {
  'use strict';
  if (window.WiseUGC) return;

  var doc = document;
  var root = doc.documentElement;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea';

  function Wall(section) {
    this.el = section;
    this.wall = section.querySelector('[data-wpc-wall]');
    this.items = all('.wpc-item', this.wall);
    this.lb = section.querySelector('[data-wpc-lb]');
    this.index = 0;
    this.lastFocus = null;
    this.cleanups = [];
    this.io = null;
    this.init();
  }

  Wall.prototype.on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts || false);
    this.cleanups.push(function () { target.removeEventListener(type, fn, opts || false); });
  };

  Wall.prototype.init = function () {
    var self = this;
    var el = this.el;
    el.classList.add('wpc--js');

    /* Visionneuse : déplacée sous <body> pour échapper aux overflow / transform des parents. */
    if (this.lb) {
      doc.body.appendChild(this.lb);
      this.stage = this.lb.querySelector('[data-wpc-stage]');
      this.counter = this.lb.querySelector('[data-wpc-current]');
      this.setupLightbox();
    }

    /* Ouverture */
    this.on(this.wall, 'click', function (e) {
      var btn = e.target.closest('[data-wpc-open]');
      if (!btn || !self.wall.contains(btn)) return;
      e.preventDefault();
      self.open(parseInt(btn.getAttribute('data-wpc-open'), 10) || 0, btn);
    });

    /* « Voir plus » (mobile) */
    var more = el.querySelector('[data-wpc-more]');
    if (more) {
      this.on(more, 'click', function () { self.expand(true); });
    }

    /* Flèches du carrousel (ordinateur) */
    var prev = el.querySelector('[data-wpc-prev]');
    var next = el.querySelector('[data-wpc-next]');
    if (prev && next) {
      var step = function (dir) {
        var w = self.wall.clientWidth * 0.85;
        self.wall.scrollBy({ left: dir * w, behavior: reduced() ? 'auto' : 'smooth' });
      };
      var update = function () {
        var max = self.wall.scrollWidth - self.wall.clientWidth - 2;
        prev.disabled = self.wall.scrollLeft <= 2;
        next.disabled = self.wall.scrollLeft >= max;
      };
      this.on(prev, 'click', function () { step(-1); });
      this.on(next, 'click', function () { step(1); });
      this.on(this.wall, 'scroll', update, { passive: true });
      this.on(window, 'resize', update, { passive: true });
      update();
    }

    this.setupReveal();
  };

  Wall.prototype.expand = function (focusFirst) {
    var el = this.el;
    if (el.classList.contains('is-expanded')) return;
    el.classList.add('is-expanded');
    var more = el.querySelector('[data-wpc-more]');
    if (more) more.setAttribute('aria-expanded', 'true');
    if (focusFirst) {
      var first = el.querySelector('.wpc-item--extra [data-wpc-open]');
      if (first) first.focus({ preventScroll: false });
    }
  };

  Wall.prototype.setupReveal = function () {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var self = this;
    var pending = this.items.filter(function (it) {
      var r = it.getBoundingClientRect();
      return r.top > window.innerHeight * 0.92; /* ce qui est déjà visible ne clignote pas */
    });
    if (!pending.length) return;
    pending.forEach(function (it) { it.classList.add('wpc-pre'); });
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('wpc-pre');
        self.io.unobserve(entry.target);
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
    pending.forEach(function (it) { self.io.observe(it); });
    this.on(window, 'beforeprint', function () {
      self.items.forEach(function (it) { it.classList.remove('wpc-pre'); });
    });
  };

  /* ---------- Visionneuse ---------- */
  Wall.prototype.setupLightbox = function () {
    var self = this;
    var lb = this.lb;

    all('[data-wpc-close]', lb).forEach(function (b) {
      self.on(b, 'click', function () { self.close(); });
    });
    var p = lb.querySelector('[data-wpc-lb-prev]');
    var n = lb.querySelector('[data-wpc-lb-next]');
    if (p) this.on(p, 'click', function () { self.go(-1); });
    if (n) this.on(n, 'click', function () { self.go(1); });

    this.on(lb, 'keydown', function (e) {
      if (lb.hidden) return;
      switch (e.key) {
        case 'Escape':
        case 'Esc':
          e.preventDefault();
          self.close();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          self.go(-1);
          break;
        case 'ArrowRight':
          e.preventDefault();
          self.go(1);
          break;
        case 'Tab':
          self.trap(e);
          break;
      }
    });

    /* Balayage tactile */
    var sx = 0, sy = 0, tracking = false;
    this.on(this.stage, 'pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      tracking = true; sx = e.clientX; sy = e.clientY;
    });
    this.on(this.stage, 'pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) self.go(dx < 0 ? 1 : -1);
    });
    this.on(this.stage, 'pointercancel', function () { tracking = false; });
  };

  Wall.prototype.trap = function (e) {
    var nodes = all(FOCUSABLE, this.lb).filter(function (n) {
      return n.offsetParent !== null || n === doc.activeElement;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && (doc.activeElement === first || !this.lb.contains(doc.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (doc.activeElement === last || !this.lb.contains(doc.activeElement))) {
      e.preventDefault(); first.focus();
    }
  };

  Wall.prototype.render = function (i, dir) {
    var count = this.items.length;
    this.index = (i + count) % count;
    var tpl = this.items[this.index].querySelector('template[data-wpc-slide]');
    this.stage.innerHTML = '';
    if (tpl) {
      var frag = tpl.content.cloneNode(true);
      var fig = frag.querySelector('.wpc-lb__fig');
      if (fig && dir < 0) fig.classList.add('is-prev');
      this.stage.appendChild(frag);
    }
    if (this.counter) this.counter.textContent = String(this.index + 1);
    this.preload(this.index + 1);
    this.preload(this.index - 1);
  };

  Wall.prototype.preload = function (i) {
    var count = this.items.length;
    if (count < 2) return;
    var item = this.items[(i + count) % count];
    if (item.__wpcPre) return;
    var tpl = item.querySelector('template[data-wpc-slide]');
    var src = tpl && tpl.content.querySelector('img');
    if (!src) return;
    var im = new Image();
    if (src.getAttribute('sizes')) im.sizes = src.getAttribute('sizes');
    if (src.getAttribute('srcset')) im.srcset = src.getAttribute('srcset');
    im.src = src.getAttribute('src');
    item.__wpcPre = true;
  };

  Wall.prototype.go = function (dir) {
    if (this.items.length < 2) return;
    this.render(this.index + dir, dir);
  };

  Wall.prototype.open = function (i, trigger) {
    if (!this.lb) return;
    this.lastFocus = trigger || doc.activeElement;
    this.render(i, 1);
    this.lb.hidden = false;
    root.classList.add('wpc-lock');
    var close = this.lb.querySelector('.wpc-lb__close');
    if (close) close.focus();
  };

  Wall.prototype.close = function () {
    if (!this.lb || this.lb.hidden) return;
    this.lb.hidden = true;
    this.stage.innerHTML = '';
    root.classList.remove('wpc-lock');
    var back = this.lastFocus;
    /* Si la photo ouverte n'est plus celle du départ, rendre le focus à sa vignette. */
    var cur = this.items[this.index] && this.items[this.index].querySelector('[data-wpc-open]');
    if (cur && cur.offsetParent !== null) back = cur;
    if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
  };

  Wall.prototype.destroy = function () {
    this.close();
    this.cleanups.forEach(function (fn) { fn(); });
    this.cleanups = [];
    if (this.io) this.io.disconnect();
    if (this.lb && this.lb.parentNode) this.lb.parentNode.removeChild(this.lb);
    this.el.__wpc = null;
  };

  /* ---------- Démarrage ---------- */
  function initIn(scope) {
    var list = [];
    if (scope.matches && scope.matches('[data-wpc]')) list.push(scope);
    list = list.concat(all('[data-wpc]', scope));
    list.forEach(function (s) {
      if (!s.__wpc) s.__wpc = new Wall(s);
    });
  }
  function destroyIn(scope) {
    var list = [];
    if (scope.matches && scope.matches('[data-wpc]')) list.push(scope);
    list = list.concat(all('[data-wpc]', scope));
    list.forEach(function (s) { if (s.__wpc) s.__wpc.destroy(); });
  }

  ready(function () { initIn(doc); });

  doc.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.wpc-item') : null;
    if (!item) return;
    var section = item.closest('[data-wpc]');
    if (section && section.__wpc && item.classList.contains('wpc-item--extra')) section.__wpc.expand(false);
    item.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced() ? 'auto' : 'smooth' });
  });

  window.WiseUGC = { init: initIn, destroy: destroyIn };
})();
